module.exports = __webpack_public_path__ + "static/img/par9.54b093c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/par_game/par9.png
// module id = id5F
// module chunks = 0